<div class="alert-container">
<span class="title-alert" id="alert-title">{{data.title}}</span>
<div mat-dialog-content>
    <div [innerHtml]="data.html"></div>
</div>